import React, { useState } from "react";
import CustomRadioButton from "../../CustomRadioButton";
import TextView from "../../../TextView";
import { Container } from "../../CreateWheelPopup.styled";
// import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { ASSETS } from "../../../../utils/config";
import EssentialPackageIcon from "@assets/images/packages/essentialPackageIcon.svg";
import { useSelector } from "react-redux";
import { getActiveSubscriptionData } from "../../../../redux/selectors/subscriptionSelectors";

function Fifth({ setAiBuilder, isAiBuilderSelected }) {
  const { data: currentPlan, loading: currentPlanLoading } = useSelector(
    getActiveSubscriptionData
  );
  const handleBuilderOptionChange = (event) => {
    if (event.target.value == "true") {
      setAiBuilder(true);
    } else {
      setAiBuilder(false);
    }
  };

  return (
    <Container>
      <TextView variant="title" style={{ textAlign: "center" }}>
        Build your Wheel from Scratch or use AI to get you started!
      </TextView>

      <TextView variant="subtitle" style={{ marginTop: "24px" }}>
        How would you like to build the wheel?
      </TextView>

      <CustomRadioButton
        options={[
          { value: false, label: "Wheel Builder" },
          {
            value: true,
            icon: currentPlan?.sub_tier === 0 && EssentialPackageIcon,
            iconTooltip: "Essential Tier feature",
            label: (
              <>
                AI Builder
                {/* <InfoOutlinedIcon fontSize="small" style={{ marginLeft: 4, color: '#888' }} />  */}
              </>
            ),
            // disabled:true
          },
        ]}
        selectedOption={isAiBuilderSelected}
        onChange={handleBuilderOptionChange}
        orientation="vertical"
      />
    </Container>
  );
}

export default Fifth;
